import React, { Fragment, FC, useMemo } from 'react';
import { Global } from '@emotion/react';
import { Message2Icon } from '@zola/zola-ui/src/components/SvgIconsV3/Message2';
import { useGladlyChat } from '@zola/zola-ui/src/hooks/useGladlyChat';

import { GladlyStyles, GladlyButton, UnreadDot } from './ZolaGladApp.styles';

const ZolaGladApp: FC = () => {
  // Provide page specific styles to prevent overlap
  const bottomPx = useMemo(() => {
    if (typeof window === 'undefined') return undefined;

    const pagePath = (window.location.pathname || '').toLowerCase();

    // Registry Shop PDP's
    if (pagePath.startsWith('/shop/product/')) {
      return '80px';
    }
    // Digital STDs
    if (pagePath.startsWith('/wedding-planning/digital/')) {
      return '100px';
    }
    // Paper PDP's
    if (
      /^\/wedding-planning\/(.*)\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(
        pagePath
      )
    ) {
      return '130px';
    }
    // Manage Registry
    if (/^\/registry\/(.*)\/edit$/.test(pagePath)) {
      return '40px';
    }
    return undefined;
  }, []);

  useGladlyChat({
    isChatEnabled: true,
    appId: 'zola.com-chat',
  });

  return (
    <Fragment>
      <Global styles={GladlyStyles} />
      <GladlyButton mobileBottom={bottomPx} type="button" id="custom-gladly-chat-button">
        <Message2Icon width={24} height={24} />
        <UnreadDot id="with-unread-message" />
      </GladlyButton>
    </Fragment>
  );
};

export default ZolaGladApp;
